<template>
    <AppCommonTopbar @menu-toggle="onMenuToggle"/>

    <Head title="Register" />

    <div class="register_container">
        <div class="register_block">

            <template v-if="form.wasSuccessful">
                <div class="success_msg">
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.4995 0.5C4.97951 0.5 0.499512 4.98 0.499512 10.5C0.499512 16.02 4.97951 20.5 10.4995 20.5C16.0195 20.5 20.4995 16.02 20.4995 10.5C20.4995 4.98 16.0195 0.5 10.4995 0.5ZM10.4995 18.5C6.08951 18.5 2.49951 14.91 2.49951 10.5C2.49951 6.09 6.08951 2.5 10.4995 2.5C14.9095 2.5 18.4995 6.09 18.4995 10.5C18.4995 14.91 14.9095 18.5 10.4995 18.5ZM15.0895 6.08L8.49951 12.67L5.90951 10.09L4.49951 11.5L8.49951 15.5L16.4995 7.5L15.0895 6.08Z" fill="#319D49"/>
                    </svg>
                    Профіль успішно зареєстровано
                </div>
            </template>

            <template v-else>
            <h2>Реєстрація</h2>
            <div class="register_from">
                <div class="field">
                    <label for="company">
                        Назва компанії
                    </label>
                    <InputText id="company"
                        v-model="form.company"
                        placeholder="Назва компанії"
                        type="company"
                        required="true"
                        class="input"
                        :class="{'p-invalid': form.errors.company || errors}"
                        @keyup.enter="submit"
                    />
                    <small v-if="form.errors.company" class="p-invalid">
                        {{ form.errors.company }}
                    </small>
                </div>
                <div class="field_group">
                    <div class="field">
                        <label for="position">
                            Посада
                        </label>
                        <InputText id="position"
                            v-model="form.position"
                            placeholder="Посада"
                            type="position"
                            required="true"
                            class="input"
                            :class="{'p-invalid': form.errors.position || errors}"
                            @keyup.enter="submit"
                        />
                        <small v-if="form.errors.position" class="p-invalid">
                            {{ form.errors.position }}
                        </small>
                    </div>
                    <div class="field">
                        <label for="code">
                            Код ЄДРПО
                        </label>
                        <InputText id="code"
                            v-model="form.code"
                            placeholder="Код ЄДРПО"
                            type="code"
                            required="true"
                            class="input"
                            :class="{'p-invalid': form.errors.code || errors}"
                            @keyup.enter="submit"
                        />
                        <small v-if="form.errors.code" class="p-invalid">
                            {{ form.errors.code }}
                        </small>
                    </div>
                </div>
                <div class="field_group">
                    <div class="field">
                        <label for="name">
                            Ім’я
                        </label>
                        <InputText id="name"
                            v-model="form.name"
                            placeholder="Введіть ім’я"
                            type="name"
                            required="true"
                            class="input"
                            :class="{'p-invalid': form.errors.name || errors}"
                            @keyup.enter="submit"
                        />
                        <small v-if="form.errors.name" class="p-invalid">
                            {{ form.errors.name }}
                        </small>
                    </div>
                    <div class="field">
                        <label for="last_name">
                            Прізвище
                        </label>
                        <InputText id="last_name"
                            v-model="form.last_name"
                            placeholder="Введіть прізвище"
                            type="last_name"
                            required="true"
                            class="input"
                            :class="{'p-invalid': form.errors.last_name || errors}"
                            @keyup.enter="submit"
                        />
                        <small v-if="form.errors.last_name" class="p-invalid">
                            {{ form.errors.last_name }}
                        </small>
                    </div>
                </div>
                <div class="field_group">
                    <div class="field">
                        <label for="email">
                            Email
                        </label>
                        <InputText id="email"
                            v-model="form.email"
                            placeholder="Введіть email"
                            type="email"
                            required="true"
                            class="input"
                            :class="{'p-invalid': form.errors.email || errors}"
                            @keyup.enter="submit"
                        />
                        <small v-if="form.errors.email" class="p-invalid">
                            {{ form.errors.email }}
                        </small>
                    </div>
                    <div class="field">
                        <label for="phone">
                            Телефон
                        </label>
                        <InputText id="phone"
                            v-model="form.phone"
                            placeholder="+380"
                            type="phone"
                            required="true"
                            class="input"
                            :class="{'p-invalid': form.errors.phone || errors}"
                            @keyup.enter="submit"
                        />
                        <small v-if="form.errors.phone" class="p-invalid">
                            {{ form.errors.phone }}
                        </small>
                    </div>
                </div>
                <div class="field_group">
                    <div class="field">
                        <label for="password">
                            Пароль
                        </label>
                        <div class="pass_container">
                            <InputText id="password_input"
                                    class="input"
                                    v-model="form.password"
                                    required="true"
                                    type="password"
                                        placeholder="Введіть пароль"
                                    autocomplete="current-password"
                                    @keyup.enter="submit"
                                    :class="{'p-invalid': form.errors.password || errors}"
                            />
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-on:click="showPassword('password_input')">
                            <path d="M8 3.41663C4.36364 3.41663 1.25818 5.67844 0 8.87117C1.25818 12.0639 4.36364 14.3257 8 14.3257C11.6364 14.3257 14.7418 12.0639 16 8.87117C14.7418 5.67844 11.6364 3.41663 8 3.41663ZM8 12.5075C5.99273 12.5075 4.36364 10.8784 4.36364 8.87117C4.36364 6.8639 5.99273 5.23481 8 5.23481C10.0073 5.23481 11.6364 6.8639 11.6364 8.87117C11.6364 10.8784 10.0073 12.5075 8 12.5075ZM8 6.68935C6.79273 6.68935 5.81818 7.6639 5.81818 8.87117C5.81818 10.0784 6.79273 11.053 8 11.053C9.20727 11.053 10.1818 10.0784 10.1818 8.87117C10.1818 7.6639 9.20727 6.68935 8 6.68935Z" fill="#6C757D"/>
                            </svg>
                        </div>

                        <small v-if="form.errors.password" class="p-invalid">
                            {{ form.errors.password }}
                        </small>
                    </div>
                    <div class="field">
                        <label for="password_confirmation">
                            Повторно введіть пароль
                        </label>
                        <div class="pass_container">
                            <InputText id="password_confirmation_input"
                                    class="input"
                                    v-model="form.password_confirmation"
                                    required="true"
                                    type="password"
                                        placeholder="Введіть пароль"
                                    autocomplete="current-password"
                                    @keyup.enter="submit"
                                    :class="{'p-invalid': form.errors.password || errors}"
                            />
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-on:click="showPassword('password_confirmation_input')">
                            <path d="M8 3.41663C4.36364 3.41663 1.25818 5.67844 0 8.87117C1.25818 12.0639 4.36364 14.3257 8 14.3257C11.6364 14.3257 14.7418 12.0639 16 8.87117C14.7418 5.67844 11.6364 3.41663 8 3.41663ZM8 12.5075C5.99273 12.5075 4.36364 10.8784 4.36364 8.87117C4.36364 6.8639 5.99273 5.23481 8 5.23481C10.0073 5.23481 11.6364 6.8639 11.6364 8.87117C11.6364 10.8784 10.0073 12.5075 8 12.5075ZM8 6.68935C6.79273 6.68935 5.81818 7.6639 5.81818 8.87117C5.81818 10.0784 6.79273 11.053 8 11.053C9.20727 11.053 10.1818 10.0784 10.1818 8.87117C10.1818 7.6639 9.20727 6.68935 8 6.68935Z" fill="#6C757D"/>
                            </svg>
                        </div>

                        <small v-if="form.errors.password" class="p-invalid">
                            {{ form.errors.password }}
                        </small>
                    </div>
                </div>
                <div class="field_group">
                    <div class="field">
                        <label class="toggle">
                            <input class="toggle__checkbox" type="checkbox" v-model="form.terms">
                            <span class="toggle__switch"></span>
                            <a href="https://vector-vs.com/policy.html" target="_blank" class="title">Я приймаю умови та політику конфіденційності</a>
                        </label>
                        <small v-if="form.errors.terms" class="p-invalid">
                            {{ form.errors.terms }}
                        </small>
                    </div>
                </div>
                <div class="field_group">
                    <div class="field">
                        <Button label="Зареєструватись"
                                type="submit"
                                @click="submit"
                                :loading="form.processing"
                        />
                    </div>
                </div>
            </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import AppCommonTopbar from "@/Components/AppCommonTopbar";
    import InputText from 'primevue/inputtext';
    import Button from 'primevue/button';

    export default defineComponent({
        components: {
            AppCommonTopbar,
            Head,
            Button,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            JetInput,
            JetCheckbox,
            JetLabel,
            JetValidationErrors,
            Link,
            InputText,
        },

        data() {
            return {
                form: this.$inertia.form({
                    company: '',
                    code: '',
                    position: '',
                    name: '',
                    last_name: '',
                    email: '',
                    phone: '+380',
                    password: '',
                    password_confirmation: '',
                    terms: true,
                })
            }
        },

        methods: {
            onMenuToggle() {
                this.menuClick = true;

                if (this.isDesktop()) {
                    if (this.layoutMode === 'overlay') {
                        if (this.mobileMenuActive === true) {
                            this.overlayMenuActive = true;
                        }

                        this.overlayMenuActive = !this.overlayMenuActive;
                        this.mobileMenuActive = false;
                    } else if (this.layoutMode === 'static') {
                        this.staticMenuInactive = !this.staticMenuInactive;
                    }
                } else {
                    this.mobileMenuActive = !this.mobileMenuActive;
                }

                event.preventDefault();
            },
            showPassword(id) {
                var x = document.getElementById(id);
                if (x.type === "password") {
                    x.type = "text";
                } else {
                    x.type = "password";
                }
            },
            submit() {
                this.form.post(this.route('register'), {
                    onFinish: () => {
                        this.form.reset('password', 'password_confirmation')
                    }
                })
            }
        }
    })
</script>

<style scoped>
.p-button {
    width: 191px;
    background: #356EEF;
    height: 48px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px!important;
    line-height: 25px;
}
.register_container{
    width: 100%;
    min-height: 100vh;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
}
.register_from {
    min-width: 636px;
}
.field {
    display: flex;
    flex-direction: column;
    width: 100%;
}
label {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: left;
    color: #6C757D;
}
.input {
    height: 48px;
    gap: 0px;
    font-size: 14px;
    width: 100%;
}
.field_group {
    display: flex;
    gap: 24px;
}
.pass_container {
    position: relative;
}

.pass_container svg {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
}
.toggle {
	 cursor: pointer;
	 display: inline-block;
}
 .toggle__switch {
	 display: inline-block;
	 background: #FFFFFF;
    border: 1.25px solid rgba(0, 0, 0, 0.15);
    border-radius: 20px;
	 width: 40px;
	 height: 20px;
	 position: relative;
	 vertical-align: middle;
	 transition: background 0.25s;
     margin-right: 20px;
}
 .toggle__switch:before, .toggle__switch:after {
	 content: '';
}
 .toggle__switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 25%);
    width: 15px;
    height: 14px;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: left 0.25s;
}
 .toggle:hover .toggle__switch:before {
	 background: linear-gradient(to bottom, #fff 0%, #fff 100%);
	 box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
 .toggle__checkbox:checked + .toggle__switch {
	 background: #0D6EFD;
}
 .toggle__checkbox:checked + .toggle__switch:before {
	 left: 21px;
}
 .toggle__checkbox {
	 position: absolute;
	 visibility: hidden;
}
 .toggle__label {
	 margin-left: 5px;
	 position: relative;
	 top: 2px;
}
.toggle span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
.p-invalid {
    color: #B70D09;
}
.success_msg {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 26px;
    font-weight: 500;
    line-height: 31.2px;
}
@media (max-width: 780px) {
    .field_group {
        flex-direction: column;
        gap: 0px;
    }
    .register_from {
        min-width: 100%;
    }
    .p-button {
        width: 100%;
    }
}
</style>
